import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  labelShrink: {
    // transform: `translate(12px, 4px) scale(0.75) !important`,
  },
}));

export default useStyles;
